import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "../Preloader/preloader.scss"


function Preloader({ isLoading }) {
  return (
    <div className={`preloader   ${!isLoading ? "hidden" : ""}` }>
      <CircularProgress size={80} className="circulo_carregar" color="inherit" />
      <p>Carregando dados...</p>
    </div>
  );
}

export default Preloader;